declare global {
  interface Window {
    readonly Matomo:
      | {
          getAsyncTrackers: () => {
            getVisitorId: () => string | undefined
          }[]
        }
      | undefined
  }
}

/**
 * The normal pattern for resolving the matomo visitorId:
 *
 * _paq.push([function () {
 *    console.log(this.getVisitorId())
 * }])
 *
 * Has been shown to be unreliable (prone to race conditions) in our setup (with multiple id cookies being set).
 *
 * This workaround retrieves the latest visitorId directly from the tracker
 */
let blocked = false
export function resolveVisitorId() {
  if (blocked) {
    return undefined
  }
  try {
    return window.Matomo?.getAsyncTrackers().at(0)?.getVisitorId()
  } catch (e) {
    blocked = true // prevent repeated errors
    reportError(e)
  }
}
